<template>
	<div>
		<div class="ft20 cl-main ftw600">课程订单</div>

		<!-- <div class="mt20 ">
			<a-radio-group v-model="search.mendian_id" button-style="solid" @change="changeMendian">
				<a-radio-button :value="item.mendian_id" v-for="(item,index) in mendians" :key="index">
					{{item.name}}
				</a-radio-button>
			</a-radio-group>
		</div> -->

		<div class="mt20">
			<div class="form-search-box ">
				<a-form layout="inline">
					<a-form-item label="订单ID">
						<a-input v-model="search.order_id" placeholder="请输入订单编号ID"></a-input>
					</a-form-item>

					<!-- <a-form-item label="老师">
						<a-input v-model="search.technician" placeholder="请输入老师姓名/手机号"></a-input>
					</a-form-item> -->
					
					<a-form-item label="客户">
						<a-input v-model="search.member" placeholder="请输入客户姓名/手机号"></a-input>
					</a-form-item>
					
					<a-form-item label="下单时间">
						<a-range-picker @change="changeAppointTime" v-model="search.add_time"  format="YYYY-MM-DD" valueFormat="YYYY-MM-DD" />
					</a-form-item>
					
					<!-- <a-form-item label="状态">
						<a-select v-model="search.status" style="width: 240px;">
							<a-select-option :value="0">全部状态</a-select-option>
							<a-select-option :value="1">待确认</a-select-option>
							<a-select-option :value="4">待到店</a-select-option>
							<a-select-option :value="8">已完成</a-select-option>
							<a-select-option :value="-1">已取消</a-select-option>
						</a-select>
					</a-form-item> -->
					
					<a-form-item label="课程分类">
						<a-select v-model="search.course_type_id" style="width: 240px;">
							<a-select-option :value="0">全部分类</a-select-option>
							<a-select-option :value="item.course_type_id" v-for="(item,index) in type_list" :key="index">{{item.name}}</a-select-option>
						</a-select>
					</a-form-item>

					<a-form-item>
						<a-button @click="searchAct" type="primary">查询</a-button>
						<a-button @click="cancelAct" class="ml10">取消</a-button>
					</a-form-item>
				</a-form>
			</div>
		</div>

		<div class="mt20">
			<div class="pd30 bg-w " style="min-height: 800px;">
				<div>
					<!-- <a-button type="primary" icon="plus" @click="addAppointmentAct()">新增订单</a-button> -->
				</div>

				<div class="flex alcenter mt10">
					<div class="">
						<a-radio-group v-model="search.status" button-style="solid" @change="changeStatus">
							<a-radio-button :value="0">
								全部
							</a-radio-button>
							<a-radio-button :value="1">
								待支付
							</a-radio-button>
							<a-radio-button :value="2">
								已支付
							</a-radio-button>
							<a-radio-button :value="3">
								已完成
							</a-radio-button>
							<a-radio-button :value="4">
								已取消
							</a-radio-button>
						</a-radio-group>
					</div>
				</div>

				<div class="mt20">
					<div class="wxb-table-gray">
						<!-- 滚动条 :scroll="{ x: 1600 }" -->
						<a-table 
							rowKey="appointment_id" 
							:columns="columns" 
							:pagination="pagination" 
							@change="handleTableChange"
							:data-source="datas" 
							:loading="loading"
							>

							<!-- 所属门店 -->
							<div class="text-center" slot="mendian" slot-scope="mendian,record" style="width: 120px;">
								{{mendian ? mendian.name : '-'}}
							</div>

							<!-- 预约时间 -->
							<div class="flex alcenter center" slot="day" slot-scope="day,record">
								<div style="line-height: 1.2;">
									<div>{{day}}</div>
									<div class="cl-theme">{{record.start_time}}-{{record.end_time}}</div>
								</div>
							</div>
							
							<!-- 用户 -->
							<div class="flex alcenter center" slot="member" slot-scope="member,record">
								<img :src="member.face"  class="member-face" />
								<div class="ml10" style="text-align: left;">
									<div>{{member.nick_name}}｜{{member.mobile}}</div>
								</div>
							</div>

							<div class="text-center" slot="course_type" slot-scope="course,record" style="width: 120px;">
								{{course.type.name ? course.type.name : '-'}}
							</div>
							
							<!-- 预约课程 -->
							<div class="flex alcenter center" slot="course" slot-scope="course,record">
								<img :src="course.cover_img"  class="course-cover-img" />
								<div class="ml10" style="text-align: left;">
									<div>{{course.course_name}}</div>
								</div>
								<!-- 单个订单多个课程 -->
								<!-- <div v-for="(item,index) in record.items">
									<img :src="item.course_cover_img"  class="course-cover-img" />
									<div class="ml10" style="text-align: left;">
										<div>{{item.course_name}}</div>
										<div>现价：￥{{item.price}}</div>
										<div>折扣{{item.discount}}</div>
									</div>
								</div> -->
							</div>
							
							<!-- <div  slot="technician" slot-scope="technician,record">
								<div class="flex alcenter center" v-if="technician">
									<img :src="technician.face"  class="member-face" />
									<div class="ml10" style="text-align: left;">
										<div>{{technician.name}}｜{{technician.mobile}}</div>
									</div>
								</div>
								<div class="flex alcenter center" v-else>待分配</div>
							</div> -->
							
							<div class="flex alcenter center" slot="status" slot-scope="status,record">
								<div>{{record.status_means}}</div>
								<!-- <div v-if="status==8 || status==-1" class="cl-notice">{{record.status_means}}</div> -->
							</div>
					
							<template slot="action" slot-scope="record,index">
								<div class="flex center">
									<a-dropdown placement="bottomRight">
										<span class="more-act">
											<i class="iconfont iconmore_gray"></i>
										</span>
										<a-menu slot="overlay">
											<a-menu-item>
												<a class="menu-act" href="javascript:;" @click="showDetailAct(record)">
													<i class="iconfont ft14 iconsee"></i>
													<span class="ml10">查看详情</span>
												</a>
											</a-menu-item>
											<!-- <a-menu-item>
												<a class="menu-act" href="javascript:;" @click="sureAppointAct(record)">
													<i class="iconfont ft14 iconorder_operation_confirm"></i>
													<span class="ml10">确认预约</span>
												</a>
											</a-menu-item> -->
											<!-- <a-menu-item v-if="record.status==2">
												<a class="menu-act" href="javascript:;"  @click="arrivalAppointAct(record)">
													<i class="iconfont ft14 iconorder_operation_cancle"></i>
													<span class="ml10">确认到店</span>
												</a>
											</a-menu-item> -->
											<!-- <a-menu-item v-if="record.status==2">
												<a class="menu-act" href="javascript:;"  @click="shuangAppointAct(record)">
													<i class="iconfont ft14 iconorder_operation_cancle"></i>
													<span class="ml10">已爽约</span>
												</a>
											</a-menu-item> -->
											<!-- <a-menu-item v-if="record.status==1 || record.status==2">
												<a class="menu-act" href="javascript:;"  @click="cancelAppointAct(record)">
													<i class="iconfont ft14 iconorder_operation_cancle"></i>
													<span class="ml10">取消预约</span>
												</a>
											</a-menu-item> -->
										</a-menu>
									</a-dropdown>
								</div>
							</template>
						</a-table>
					</div>
				</div>
			</div>
		</div>
	
		<div v-if="addAppointmentVisible">
			<add-appointment :visible="addAppointmentVisible" @cancel="cancelAddAppointment" @ok="okAddAppointment"></add-appointment>
		</div>
		<div v-if="showDetailVisible">
			<order-detail :visible="showDetailVisible" :order="order" @cancel="cancelShowDetail" @sureAppoint="sureAppoint" 
			@cancelAppoint="cancelAppoint" @sureWriteOff="sureWriteOff"></order-detail>
		</div>
		<div v-if="cancelAppointVisible">
			<cancel-appoint :appointment_id="appointment_id" :visible="cancelAppointVisible" @cancel="cancelCancelAppoint" @ok="okCancelAppoint"></cancel-appoint>
		</div>
	</div>
</template>

<script>
	import {
		listMixin
	} from '../../common/mixin/list.js';
	import addAppointment from './components/order/modal/addAppointment.vue';
	import orderDetail from './components/order/modal/detail.vue';
	import cancelAppoint from './components/order/modal/detail/modal/cancelAppoint.vue';
	export default {
		mixins: [listMixin],
		components:{
			addAppointment,
			orderDetail,
			cancelAppoint,
		},
		data() {
			return {
				loading: false,
				addAppointmentVisible:false,
				showDetailVisible:false,
				cancelAppointVisible:false,
				order:{},
				appointment_id:0,
				pagination: {
					current: 1,
					pageSize: 10, //每页中显示10条数据
					total: 0,
				},
				search: {
					order_id:'',
					technician:'',
					member:'',
					add_time:[],
					status: 0,
					course_type_id:0,
					mendian_id:0
				},
				type_list:[],
				columns: [
					{title: '订单ID',dataIndex: 'order_id',align: 'center', width:60},
					{title: '用户',dataIndex: 'member',align: 'center',width:150,scopedSlots: {customRender: 'member'}},
					{title: '课程分类',dataIndex: 'course',align: 'center',width:120,scopedSlots: {customRender: 'course_type'}},
					{title: '课程',dataIndex: 'course',align: 'center',width:300,scopedSlots: {customRender: 'course'}},
					// {title: '预约老师',dataIndex: 'technician',align: 'center',width:150,scopedSlots: {customRender: 'technician'}},
					{title: '所属门店',dataIndex: 'mendian',align: 'center', width:120, scopedSlots: {customRender: 'mendian'}},
					{title: '下单时间',dataIndex: 'add_time_format',align: 'center', width:120}, // 过长省略号ellipsis: true
					{title: '核销时间',dataIndex: 'verification_time_format',align: 'center', width:120, scopedSlots: {customRender: 'verification_time_format'}},
					{title: '状态',dataIndex: 'status',align: 'center',width:120, scopedSlots: {customRender: 'status'}},
					{title: '操作',key: 'action',align: 'center',scopedSlots: {customRender: 'action'}}
				],
				datas: [],
				mendians: []
			}
		},
		created(){
			this.getMendians();
		},
		methods: {
			getMendians(){
				this.$http.api('admin/getAllMendian').then(res=>{
					this.mendians = res.mendian;
				}).catch(res=>{
					console.log(res);
				});
			},
			getLists() {
				if(this.loading==true) return;
				this.loading=true;
				this.$http.api('admin/getCourseOrderList',{
					limit:this.pagination.pageSize,
					page:this.pagination.current,
					order_id:this.search.order_id,
					member:this.search.member,
					technician:this.search.technician,
					add_time:this.search.add_time,
					course_type_id:this.search.course_type_id,
					status:this.search.status,
					mendian_id:this.search.mendian_id,
				}).then(res=>{
					this.pagination.total=res.total;
					this.datas=res.list;
					if(res.type_list){
						this.type_list=res.type_list;
					}
					this.loading=false;
				}).catch(res=>{
					console.log(res);
					this.loading=false;
				})
			},
			
			sureAppointAct(record){
				this.$confirm({
					title:'确认这个预约吗？',
					okText:"确定",
					okType:"danger",
					cancelText:"取消",
					onOk : ()=>{
						return new Promise((resolve,reject)=>{
							this.$http.api('admin/sureAppointment',{
								appointment_id:record.appointment_id,
							}).then(res=>{
								this.$message.success('确认成功');
								this.getLists();
							}).catch(res=>{
								console.log(res);
							}).finally(()=>{
								resolve();
							})
						})
					}
				})
			},
			
			arrivalAppointAct(record){
				this.$confirm({
					title:'确认已经到店了吗？',
					okText:"确定",
					okType:"danger",
					cancelText:"取消",
					onOk : ()=>{
						return new Promise((resolve,reject)=>{
							this.$http.api('admin/arrivalAppointment',{
								appointment_id:record.appointment_id,
							}).then(res=>{
								this.$message.success('操作成功');
								this.getLists();
							}).catch(res=>{
								console.log(res);
							}).finally(()=>{
								resolve();
							})
						})
					}
				})
			},

			shuangAppointAct(record){
				this.$confirm({
					title:'确认已经爽约了吗？',
					okText:"确定",
					okType:"danger",
					cancelText:"取消",
					onOk : ()=>{
						return new Promise((resolve,reject)=>{
							this.$http.api('admin/shuangAppointment',{
								appointment_id:record.appointment_id,
							}).then(res=>{
								this.$message.success('操作成功');
								this.getLists();
							}).catch(res=>{
								console.log(res);
							}).finally(()=>{
								resolve();
							})
						})
					}
				})
			},
			
			//新增预约
			addAppointmentAct(){
				this.addAppointmentVisible=true;
			},
			cancelAddAppointment(){
				this.addAppointmentVisible=false;
			},
			okAddAppointment(){
				this.addAppointmentVisible=false;
				this.getLists();
			},
			
			//查看订单详情
			showDetailAct(record){
				this.order=record;
				this.showDetailVisible=true;
			},
			cancelShowDetail(){
				this.showDetailVisible=false;
			},
			sureAppoint(){
				this.showDetailVisible=false;
				this.getLists();
			},
			cancelAppoint(){
				this.showDetailVisible=false;
				this.getLists();
			},
			sureWriteOff(){
				this.showDetailVisible=false;
				this.getLists();
			},
			
			//取消预约
			cancelAppointAct(record){
				this.appointment_id=record.appointment_id;
				this.cancelAppointVisible=true;
			},
			cancelCancelAppoint(){
				this.cancelAppointVisible=false;
			},
			okCancelAppoint(){
				this.cancelAppointVisible=false;
				this.getLists();
			},
			
			changeAppointTime(value){
				this.search.add_time=value;
			},
			
			handleTableChange(pagination, filters, sorter) {
				this.pagination.current = pagination.current;
				this.getLists();
			},

			changeStatus() {
				this.pagination.current = 1;
				this.getLists();
			},
			changeMendian() {
				this.pagination.current = 1;
				this.getLists();
			},
		}
	}
</script>

<style>
	.course-cover-img{
		width: 50px;
		height: 50px;
	}
	
	.member-face{
		width: 40px;
		height: 40px;
		border-radius: 20px;
	}
</style>
